import { render, staticRenderFns } from "./EditRealworksStatusRuleForm.vue?vue&type=template&id=1bdc205a&"
import script from "./EditRealworksStatusRuleForm.vue?vue&type=script&lang=ts&"
export * from "./EditRealworksStatusRuleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports